export default "__VITE_ASSET__Dt54xAs6__"